import React from "react";
import Button from "../components/Button";

export default function ErrorPage() {
  const resetErrorBoundary = () => (window.location.href = "/");

  return (
    <div className="error-container d-flex justify-content-center align-items-center">
      <div className="container text-center">
        <p className="fw-bolder" style={{ color: "red", fontSize: "30px" }}>
          404 Page Not Found
        </p>
        <Button
          className="px-3 py-2 rounded-pill"
          text_color="white"
          children={<>Back to home</>}
          background_color="red"
          onClick={resetErrorBoundary}
        />
      </div>
    </div>
  );
}
